import { normalizeText } from './TextHelpers';

/** Whole words that must all be present for a certification to count as a Standard Work Trainer cert. */
const STANDARD_WORK_TRAINER_TOKENS = ['standard', 'work', 'trainer'] as const;

/**
 * Determines whether a certification name identifies a Standard Work Trainer certificate.
 *
 * The name must contain the words "standard", "work", and "trainer" — each as a whole word,
 * in any order and not necessarily adjacent. Matching is done on tokens (split on non-alphanumeric
 * characters) rather than substrings so near-forms such as "standards" do NOT qualify.
 *
 * @param name - The certification name to test.
 * @returns True when the name contains all three tokens as whole words.
 */
export const isStandardWorkTrainerCert = (name: string): boolean => {
    const tokens = new Set(normalizeText(name).split(/[^a-z0-9]+/).filter(Boolean));
    return STANDARD_WORK_TRAINER_TOKENS.every(token => tokens.has(token));
};

/**
 * Case-insensitive, normalized substring match of a search query against a certification name.
 * Shared by the cert search boxes so the match rule stays consistent across them.
 *
 * @param name - The certification name to test.
 * @param query - The user's search text.
 * @returns True when the normalized name contains the normalized query.
 */
export const certNameMatches = (name: string, query: string): boolean =>
    normalizeText(name).includes(normalizeText(query));
